import { Component } from '@angular/core';

@Component({
  selector: 'app-key-figures',
  templateUrl: './key-figures.component.html',
  styleUrls: ['./key-figures.component.scss']
})
export class KeyFiguresComponent {

}
